
<div class="column">
    <h2>Pazienti globali - Utenti inattivi per malattia iniziale attiva/inattiva (analisi MIAH)</h2>
    <h3>L'analisi è stata effettuata considerando i pazienti che hanno compilato il questionario MIAH.</h3>
    <h3> Cut-off: 3,6.</h3>  
    <div style="display: inline-block" style="padding-left: 2vw; padding-top: 1vw">
      <div class = "chart-container" >
        <canvas id = "myChartInactiveMalattiaInizialeMIAH"></canvas>
      </div>
    </div>
  </div>
  